/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TextBulletGroupIcon16Solid = forwardRef('TextBulletGroupIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1 3.25C1 2.56 1.56 2 2.25 2h2.5C5.44 2 6 2.56 6 3.25v2.5C6 6.44 5.44 7 4.75 7h-2.5C1.56 7 1 6.44 1 5.75v-2.5Z" }),
        React.createElement("path", { d: "M8 2a1 1 0 0 0 0 2h5a1 1 0 1 0 0-2H8Z" }),
        React.createElement("path", { d: "M7 6a1 1 0 0 1 1-1h5a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Z" }),
        React.createElement("path", { d: "M8 8a1 1 0 0 0 0 2h5a1 1 0 1 0 0-2H8Z" }),
        React.createElement("path", { d: "M8 11a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2H8Z" }),
        React.createElement("path", { d: "M2.25 8C1.56 8 1 8.56 1 9.25v2.5c0 .69.56 1.25 1.25 1.25h2.5C5.44 13 6 12.44 6 11.75v-2.5C6 8.56 5.44 8 4.75 8h-2.5Z" })));
});
